import { render, staticRenderFns } from "./post_status.vue?vue&type=template&id=24000ed0&scoped=true&"
import script from "./post_status.vue?vue&type=script&lang=js&"
export * from "./post_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24000ed0",
  null
  
)

export default component.exports